import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import ReactGA from 'react-ga'
import history from './history'

// Import theming
import theme from './theme'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'

// Import constants
import { GA_ID } from './constants'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

// Enable Google Analytics if we have a GA_ID
if (GA_ID) {
  console.log('Enabling Google Analytics')
  ReactGA.initialize(GA_ID)
  ReactGA.pageview(window.location.pathname + window.location.search)
}

ReactDOM.render((
  <Router history={history}>
    <MuiThemeProvider theme={theme}>
      <App />
    </MuiThemeProvider>
  </Router>
), document.getElementById('root'))

registerServiceWorker()
